import React, { useContext, useEffect, useState} from 'react';
import {IProps, IState} from './types';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import Button from '@components/Button';
import * as S from './styles';
import C from '@assets/themes/colors';
import { BrandsContext } from '@utils/DOIgnition/BrandsContext';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { IElementUpdate, IActionInfo, IBrandColor} from '../../../../../../state/brands/types';
import { IBrandImage } from '../../../../../../state/brandsImages/types';
const uuid = require('react-uuid');

const imageFileTypes = [
  'image/png', 'image/jpeg', 'image/svg+xml'
];


const DeleteItem:React.FC<IProps> = (props) => {
  const authContext = useContext(AuthContext);
  const { brandAction, brandDetail, addUpdateBrand, setBrandAction, movefile} = useContext(BrandsContext);
  const element = brandAction.element;
  const moveFileResponse = useSelector(selectors.brands.getMoveFileResponse);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  useEffect(() => {
    if (moveFileResponse?.status >= 200 && moveFileResponse?.status <= 300) {
      let splitPath = moveFileResponse.data.split('/');
      if (splitPath[2]) updateBrand(splitPath[2]);
      else updateBrand("");
    }
}, [moveFileResponse])

  const updateBrand = (newFile?: string) => {
    let element : any  = {...brandAction.element};

    let newAction : IActionInfo = {
      user: {
        email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
        name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
      },
      date: new Date(),
      action:"DELETE"
    }
    element.actions.push(newAction);

    if (newFile) {
      element.srcImage = newFile.split('.')[0];
      element.format = newFile.split('.')[1];
      element.status = "INACTIVE";
    }

    let updateInfo : IElementUpdate = {
      action: "DELETE", //INSERT DELETE UPDATE
      field: brandAction.section.toUpperCase(),
      value: element
    }
    addUpdateBrand([updateInfo], undefined, undefined, undefined, undefined, `1 ${brandAction.section==="colors" ? 'color' : 'file' } deleted.`);
  }

  const handleDelete = () => {
    if(element) {
      setIsSaving(true);
      if (brandAction.section!=="colors") movefile(element.srcImage, element.format);
      else updateBrand();
    }
  }

  const elementNameSplitted = props.elementName.split(' ');

  return (
    <S.Root style={{
      display: props.open ? 'flex' : 'none',
    }} >
      <S.BoxContainer>
        <S.TitleContainer>
          <S.LeftSide>
            <S.Title>
            Delete {elementNameSplitted[1] ?? elementNameSplitted[0]}
            </S.Title>
          </S.LeftSide>
        </S.TitleContainer>
        <S.Content>
            <S.Description>
              {brandAction?.section === 'colors' 
              ? 'Are you sure you want to delete this color?'
              : `If you delete this ${props.elementName.toLocaleLowerCase()}, ${element?.templatesCount ?? 0} templates and ${element?.designsCount ?? 0} designs files will reflect this change. `}
            </S.Description>
        </S.Content>
        <S.ActionsContainer>
          <S.Action>
            <Button
              label="CANCEL"
              style={{
                width: '112px',
                marginRight: 12, 
                backgroundColor: "transparent", 
                border: `1px solid ${C.BLUE}`, 
                hoverBackgroundColor: `${C.BLUE}22`,
              }}
              labelStyle={{color: C.BLUE}}
              onClick={() => setBrandAction(undefined)}
              disabled={isSaving}
            />
          </S.Action>
          <S.Action>
            <Button
              label={props.isSaving ? "DELETING..." : "DELETE"}
              style={{
                width: '112px',
                backgroundColor: C.BLUE, 
                flexGrow: 0, 
                hoverBackgroundColor: `${C.BLUE}AA`,
              }} 
              onClick={()=>handleDelete()}
              disabled={isSaving}
            />
          </S.Action>
        </S.ActionsContainer>
      </S.BoxContainer>
    </S.Root>
  );
}

export default DeleteItem;